import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { useCidadaoPainelChamadasQuery, useSalasUnidadeSaudeQuery } from 'graphql/hooks.generated'
import { useSessionStorageState } from 'hooks/useStorage'
import { useEffect, useMemo } from 'react'
import { useHistory, useParams } from 'react-router'
import { emptyArrayOf } from 'util/array'

import { useListaAtendimentoActionsLoading } from '../../hooks/useListaAtendimentoActionsLoading'
import { ChamarCidadaoModalForm } from './ChamarCidadaoModalForm'
import { ChamarCidadaoPainelChamadaModel, TipoAtendimentoPainelChamadaEnum } from './model-painelChamada'

interface UrlParams {
  atendimentoId: string
}

interface ChamarCidadaoPreferences {
  salaId?: ID
  tipoAtendimento?: TipoAtendimentoPainelChamadaEnum
}

export function ChamarCidadaoView() {
  const { atendimentoId } = useParams<UrlParams>()
  const { stopLoading } = useListaAtendimentoActionsLoading()
  const { acesso } = useAcessoLotacaoOrEstagio()
  const { data: dataCidadao, loading: loadingCidadao } = useCidadaoPainelChamadasQuery({
    variables: { id: atendimentoId },
  })
  const { data: dataSalas, loading: loadingSalas } = useSalasUnidadeSaudeQuery({
    variables: { unidadeSaudeId: acesso.unidadeSaude.id },
  })
  const history = useHistory()

  const acessoId = acesso?.id
  const [preferences, setPreferences] = useSessionStorageState<ChamarCidadaoPreferences>(
    `${acessoId}/chamar-cidadao-preferences`,
    { defaultValue: { tipoAtendimento: TipoAtendimentoPainelChamadaEnum.ATENDIMENTO } }
  )

  const isLoading = loadingCidadao || loadingSalas
  useEffect(() => {
    if (!isLoading) {
      stopLoading()
    }
  }, [isLoading, stopLoading])

  const handleSuccess = (salaId: ID, tipoAtendimento: TipoAtendimentoPainelChamadaEnum) => {
    setPreferences({ salaId, tipoAtendimento })
    handleClose()
  }

  const initialValues = useMemo((): Partial<ChamarCidadaoPainelChamadaModel> => {
    const salas = dataSalas?.salasUnidadeSaude ?? emptyArrayOf()
    const salaEncontrada = salas.find((sala) => sala.id === preferences.salaId)

    return {
      tipoAtendimento: preferences.tipoAtendimento,
      sala: salaEncontrada ? { id: salaEncontrada.id, label: salaEncontrada.nome } : undefined,
    }
  }, [dataSalas?.salasUnidadeSaude, preferences.salaId, preferences.tipoAtendimento])

  if (!dataCidadao?.atendimento || !dataSalas?.salasUnidadeSaude) {
    return null
  }

  const handleClose = () => {
    return history.push('/lista-atendimento')
  }

  return (
    <ChamarCidadaoModalForm
      atendimento={dataCidadao.atendimento}
      salas={dataSalas.salasUnidadeSaude ?? emptyArrayOf()}
      initialValues={initialValues}
      onClose={handleClose}
      onSuccess={handleSuccess}
    />
  )
}
